import React, { useEffect, useRef } from "react";
import containerStyles from "../WidgetContainer/WidgetContainer.module.css";
import s from "./WidgetProcessingStep.module.css";
import LoaderSpinner from "@/components/Loader/LoaderSpinner";

const WidgetProcessingStep = ({ isMobile }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Автоматический скролл вниз при появлении
    if (containerRef.current) {
      setTimeout(() => {
        containerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className={`${containerStyles.loading} ${s.loading}`}
    >
      <div className={containerStyles.loadingContent}>
        <LoaderSpinner />
        <p className={containerStyles.loadingText}>
          Генерация обычно занимает 30-60 секунд
        </p>
      </div>
    </div>
  );
};

export default WidgetProcessingStep;
